// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { primaryImageStyles } from "@pace/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { mergeWithCss, sharedBadgeStyle, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

primaryImageStyles.primaryImage = {
    ...primaryImageStyles.primaryImage,
    centeringWrapper: {
        css: css`
            border-radius: 4px;
            overflow: hidden;
            margin: 0;
            img {
                width: 430px;
                height: 430px;
            }
            ${xScreen("lte", "sm")} {
                img {
                    width: auto;
                    height: 100%;
                }
            }
        `,
    },
};
primaryImageStyles.badge = {
    badgeText: {
        ...sharedBadgeStyle.badgeText,
    },
    ...mergeWithCss(sharedBadgeStyle.badge, {
        css: css`
            margin: 0 0 4px;
            & > div {
                border-radius: 0 4px;
            }
        `,
    }),
};

primaryImageStyles.brand = {
    logoImage: {
        css: css`
            width: 118px;
            height: 60px;
            position: absolute;
            left: 8px;
            top: 8px;

            img {
                max-width: 100%;
                max-height: 100%;
                width: auto;
            }
        `,
    },
    nameText: {
        css: css`
            position: absolute;
            left: 8px;
            top: 8px;
        `,
    },
};
primaryImageStyles.fullPrimaryImageModal = {
    cssOverrides: {
        modalTitle: css`
            &&&&::after {
                content: none;
            }
        `,
    },
};

primaryImageStyles.fullPrimaryImage = {
    img: {
        css: css`
            max-height: 340px;
            object-fit: contain;
        `,
    },
};
